import axiosInstance from "../api/axiosInstance";
import { DISPATCH_SUMMARIES } from "../constants/API_URLs";

export const getDispatchSummaries = (params: any): Promise<any> => {
  return axiosInstance.get(DISPATCH_SUMMARIES, { params });
};

export const exportExcelDispatchSummary = (params: any): Promise<any> => {
  return axiosInstance.get(`${DISPATCH_SUMMARIES}/export/excel`, {
    params,
    responseType: "blob",
  });
};
